import { PERSONAL_DETAILS } from '@/core/field-names';
import { PersonalDetailsFieldErrors } from '@/core/validation/field-errors';

export async function validatePersonalDetailsCommonFields(field) {
  switch (field.name) {
    case PERSONAL_DETAILS.GENDER: {
      if (!field.value) {
        return PersonalDetailsFieldErrors.EmptyGender;
      }
      break;
    }
    case PERSONAL_DETAILS.DOB: {
      if (!field.value) {
        return PersonalDetailsFieldErrors.EmptyDOB;
      }
      const date = new Date(field.value);
      const now = new Date();
      if (date > now) {
        return PersonalDetailsFieldErrors.EmptyDOB;
      }
      break;
    }
    case PERSONAL_DETAILS.ADDRESS: {
      if (!field.addressValue && !field.value) {
        return PersonalDetailsFieldErrors.EmptyAddress;
      }

      if (!field.addressValue && field.value) {
        return PersonalDetailsFieldErrors.InvalidAddress;
      }
      break;
    }
    case PERSONAL_DETAILS.EMERGENCY_CONTACT_NAME: {
      if (!field.value) {
        return PersonalDetailsFieldErrors.EmptyEmergencyContactName;
      }
      break;
    }
    case PERSONAL_DETAILS.MOBILE:
    case PERSONAL_DETAILS.EMERGENCY_CONTACT_MOBILE: {
      if (!field.mobileValue) {
        return PersonalDetailsFieldErrors.MobileNumberRequired;
      }
      if (!field.mobileValue.countryCode || !field.mobileValue.number) {
        return PersonalDetailsFieldErrors.MobileNumberRequired;
      }
      const regex = /^\+[1-9]\d{10,14}$/;
      // Remove whitespace from the number, as some dial code can have space for example Puerto Rico +1 939
      const num = (
        field.mobileValue.countryCode + field.mobileValue.number
      ).replace(/\s/g, '');
      if (!regex.test(num)) {
        return PersonalDetailsFieldErrors.MobileNumberInvalid;
      }
      break;
    }
    case PERSONAL_DETAILS.EMERGENCY_CONTACT_RELATIONSHIP: {
      if (!field.value) {
        return PersonalDetailsFieldErrors.EmptyEmergencyContactRelationship;
      }
      break;
    }
    case PERSONAL_DETAILS.TITLE: {
      if (!field.value) {
        return PersonalDetailsFieldErrors.EmptyTitle;
      }
      break;
    }
    case PERSONAL_DETAILS.FIRST_NAME: {
      const firstName = (field.value || '').trim();
      if (!firstName) {
        return PersonalDetailsFieldErrors.EmptyFirstName;
      }
      if (!/^\p{L}[\p{L}\p{M}\p{N}\s]*(-[\p{L}\p{M}\p{N}][\p{L}\p{M}\p{N}\s]*)*$/u.test(firstName)) {
        return PersonalDetailsFieldErrors.InvalidFirstName;
      }
      break;
    }
    case PERSONAL_DETAILS.LAST_NAME: {
      const lastName = (field.value || '').trim();
      if (!lastName) {
        return PersonalDetailsFieldErrors.EmptyLastName;
      }
      if (!/^\p{L}[\p{L}\p{M}\p{N}\s]*(-[\p{L}\p{M}\p{N}][\p{L}\p{M}\p{N}\s]*)*$/u.test(lastName)) {
        return PersonalDetailsFieldErrors.InvalidLastName;
      }
      break;
    }
  }

  return '';
}
